import { render, staticRenderFns } from "./ServicePaymentManageList.vue?vue&type=template&id=38c125ad"
import script from "./ServicePaymentManageList.vue?vue&type=script&lang=js"
export * from "./ServicePaymentManageList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports